import AccountService, { AccountServicesByServiceId, HasActiveAccountServicesByServiceId } from "./AccountService"
import { ServiceCode } from "../../LookupCodes/ServiceCode"

export default interface Service {
  ServiceID: number
  ServiceName: string
  ServiceDescription: string
  ServiceCode: string
  SampleType?: string
  ServiceTypeID: number
  DOT: boolean
  ActiveWorkForce: boolean
  ActivateAll: boolean
  Marketplace: boolean
  DisplayOrder: number
  FFServiceCode: string
  MPSku: string
}

const emptyService = {
  ServiceID: 0,
  ServiceName: "",
  ServiceDescription: "",
  ServiceCode: "",
  SampleType: "",
  ServiceTypeID: 0,
  DOT: false,
  ActiveWorkForce: false,
  ActivateAll: false,
  Marketplace: false,
  DisplayOrder: 0,
  FFServiceCode: "",
  MPSku: "",
}

export function ServiceById(items: Service[], serviceId: number) {
  return items.find((item) => item.ServiceID === serviceId) || emptyService
}

export function ServiceByCode(items: Service[], code: ServiceCode): Service {
  return items.find((item) => item.FFServiceCode === code) || emptyService
}

export function ServicesByServiceTypeId(items: Service[], serviceTypeId: number) {
  return items.filter((item) => item.ServiceTypeID === serviceTypeId)
}

export function ServicesByServiceSampleType(items: Service[], sampleType: string) {
  return items.filter((item) => item.SampleType === sampleType)
}

export function AccountsForServices(services: Service[], accountServices: AccountService[]) {
  return services.reduce((result: AccountService[], service) => {
    const accounts = AccountServicesByServiceId(accountServices, service.ServiceID)
    return result.concat(accounts)
  }, [])
}

export function IsServiceActive(service: Service, accountServices: AccountService[]) {
  return service.ActiveWorkForce && HasActiveAccountServicesByServiceId(accountServices, service.ServiceID)
}

export function IsServiceCodePOCT(code: ServiceCode) {
  return code === ServiceCode.POCT
}

export function IsServiceCodeFLEX(code: ServiceCode) {
  return code === ServiceCode.FLEX
}

export function IsServiceCodeWellness(code: ServiceCode) {
  return code === ServiceCode.Wellness
}

export function IsServiceCodeCHSBL(code: ServiceCode | string) {
  return code === ServiceCode.Clinical
}
